import React from 'react';
import './styles.scss';

export function FullWidthButton(props: {
    type: 'primary' | 'secondary';
    color: 'blue' | 'white';
    text: string;
    onClick?: () => void;
}): JSX.Element {
    return (
        <button className={`full-width-button ${props.type} ${props.color}`} onClick={props.onClick}>
            {props.text.toUpperCase()}
        </button>
    );
}

export function TileButton(props: { svg: string; label: string; onClick: () => void }): JSX.Element {
    return (
        <button className='label-button' onClick={props.onClick}>
            <svg className='icon-24'>
                <use xlinkHref={`#${props.svg}`}></use>
            </svg>
            <p className='body small'>
                {props.label}
                <svg className='icon-16'>
                    <use xlinkHref={`#as-arrow-right`}></use>
                </svg>
            </p>
        </button>
    );
}

interface TextlinkProps {
    type?: 'svg-right' | 'svg-left';
    color: 'dark-blue' | 'light-blue' | 'white';
    text: string;
    svg?: string;
    onClick: () => void;
}
export function Textlink(props: TextlinkProps): JSX.Element {
    return (
        <button className={`textlink ${props.type} ${props.color}`} onClick={() => props.onClick()}>
            <p>{props.text}</p>
            {props.svg && (
                <svg className='icon-24'>
                    <use xlinkHref={props.svg}></use>{' '}
                </svg>
            )}
        </button>
    );
}

export function CancelXButton(props: {
    onClick: () => void;
    color: 'blue' | 'white';
}): JSX.Element {
    return (
        <button className={`cancel-x-button ${props.color}`} onClick={() => props.onClick()}>
            <svg className='icon-12'>
                <use xlinkHref='#as-close'></use>
            </svg>
        </button>
    );
}

export function FloatingCancelXButton(props: {
    onClick: () => void;
}): JSX.Element {
    return (
        <button className='cancel-x-button-floating' type='button' onClick={props.onClick}>
            <svg>
                <use xlinkHref='#as-close-inverted'></use>
            </svg>
        </button>
    );
}
